import React from "react";

export type ZoomPanContextState = {
  scale: number;
};

export default React.createContext<ZoomPanContextState>({
  scale: 1,
});
